module.exports = __webpack_public_path__ + "static/media/behind_the_scenes.81f47938.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Lag/images/animations/behind_the_scenes.png
// module id = 1482
// module chunks = 39